import { useEffect, useRef } from 'react'
import { useLocation } from 'router-v6'
import { PAGE_VIEW_DEBOUNCE_MS, trackHubspotPageView } from 'v2/utils/hubspot'

/**
 * Feeds SPA navigations to the HubSpot tracking code.
 *
 * Mounted under the router but OUTSIDE the authenticated tree — the anonymous funnel
 * (/signup, /login, /complete-signup) is most of what HubSpot is here for, and those
 * routes never mount MainLayout's `EffectsHandler` where the other trackers live.
 */
export const HubspotTracker = () => {
  const { pathname } = useLocation()
  const isInitialRoute = useRef(true)

  useEffect(() => {
    // Skipped on mount: the tracking code already recorded a page view of its own at
    // this path when it loaded, and reporting it again double-counts the entry page.
    if (isInitialRoute.current) {
      isInitialRoute.current = false
      return
    }

    const timer = setTimeout(() => trackHubspotPageView(pathname), PAGE_VIEW_DEBOUNCE_MS)
    return () => clearTimeout(timer)
    // Keyed on pathname alone: in-app query strings are view state (filters, tabs,
    // and the odd single-use token), not pages.
  }, [pathname])

  return null
}
